import React, { useEffect, useRef, useState, useContext } from 'react'
import "./Book_cancel_modal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Success_modal from "../Success_modal/Success_modal";
import { useForm } from 'react-hook-form';
import { ProfileGet, EditProfile, getBooking, cancelBooking, postCancelBooking } from "../../../../utils/apis/myAccount/myAccount";
const Book_cancel_modal = (props) => {
  const [modalShow4, setModalShow4] = useState(false);
  const [data, setData] = useState();
  const [errorMessage, setErrorMessage] = useState('');
  // const handleSubmit = () => {
  //   setModalShow4(true);
  //   props.onHide();
  // };


  const getAllData = async () => {
    const res = await cancelBooking();
    if (res?.success) {
      setData(res?.data);
      setErrorMessage('');
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }
  useEffect(() => {
    getAllData();

  }, []);
  const { register, handleSubmit, watch } = useForm();
  const onSubmit = async (data) => {
    const datafinal = {
      reason_id: data?.reason_id,
      remark: data?.remark,
      booking_id: props?.ID,
    };
    let res;
    try {
      res = await postCancelBooking(datafinal);
      if (res?.success) {
        setModalShow4(true);
        setErrorMessage('');
        props.onHide();
        props.getAllBookingData();
      } else {
        console.log(res, 'res'); // This should now always log
        setErrorMessage(res?.message);
      }
    } catch (error) {
      console.error('Error in postCancelBooking:', error);
      setErrorMessage(error?.message);
    }
  };


  console.log(errorMessage, "errorMessage errorMessage");


  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="booking-cancel-modal"
      >
        {/* <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Modal heading
                    </Modal.Title>
                </Modal.Header> */}
        <Modal.Body>
          <div className="text-center">
            <h4 className="title">Booking Cancellation</h4>
          </div>
          <p style={{ color: "red", margin: "0" }}>
            Note: Except for tax and platform charges, the amount is credited.
          </p>
          {errorMessage && (
            <p style={{ color: "red", margin: "0" }}>{errorMessage}</p>
          )}

          <div className="reasons-div">
            <p className="resaop-pp">Select a reason for Cancellation</p>

            <Form>
              {["radio"].map((type) => (
                <div key={`inline-${type}`} className="mb-3">
                  {data?.map((val) => (
                    <Form.Check
                      key={val?.id}
                      label={val?.name}
                      name="group1"
                      type={type}
                      id={val?.id}
                      value={val?.id} // Set the value to the ID
                      {...register("reason_id")} // Register the input with react-hook-form
                    />
                  ))}
                  {/* {data?.map((val)=>
                  <Form.Check
                    label={val?.name}
                    name="group1"
                    type={type}
                    id={val?.id}
                  />
                )} */}

                  {/* <Form.Check
                    label="Lorem Ipsum Is Simply Dummy Text Of The Printing And Typesetting Industry."
                    name="group1"
                    type={type}
                    id={`inline-${type}-2`}
                  />

                  <Form.Check
                    label="Lorem Ipsum Is Simply Dummy Text Of The Printing"
                    name="group1"
                    type={type}
                    id={`inline-${type}-3`}
                  />

                  <Form.Check
                    label="Lorem Ipsum Is Simply Dummy Text Of The Printing"
                    name="group1"
                    type={type}
                    id={`inline-${type}-4`}
                  />

                  <Form.Check
                    label="Other"
                    name="group1"
                    type={type}
                    id={`inline-${type}-5`}
                  /> */}
                </div>
              ))}


              <Form.Label
                className="mb-2 input_label"
              >
                Enter your reason
              </Form.Label>
              <Form.Control
              className='textarea_input'
                as="textarea"
                type="text"
                name="remark"
                placeholder="Leave a comment here"
                {...register("remark", {

                })}

              />
              {/* <Form.Control as="textarea" placeholder="Leave a comment here" /> */}

            </Form>
            <div className="d-flex justify-content-center mt-5">
              <button className="cancel-btn" onClick={props.onHide}>
                CANCEL
              </button>
              <button type="button" className="submit-btn" onClick={handleSubmit(onSubmit)}>
                SUBMIT
              </button>
            </div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer>
                    <Button onClick={props.onHide}>Close</Button>
                </Modal.Footer> */}

      </Modal>


      <Success_modal
        maintext={"Booking Cancelled Successfully"}
        show={modalShow4}
        onHide={() => setModalShow4(false)}
      />
    </>
  );
};

export default Book_cancel_modal;